<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div style="float: right">
        <md-button class="md-primary" :disabled="isDisabled" @click="exportData()">Export</md-button>
      </div>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Orders</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <!-- Email -->
            <div class="md-layout-item md-size-25">
              <md-field>
                <md-input type="text" placeholder="Email" v-model="email"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field>
                <md-input type="text" placeholder="Phone Number" v-model="phoneNumber"></md-input>
              </md-field>
            </div>
            
            <!-- Referral Code Filter -->
            <div class="md-layout-item md-size-20">
              <md-field>
                <md-input 
                  type="text" 
                  placeholder="Referral Code" 
                  v-model="referralCode"
                ></md-input>
              </md-field>
            </div>

            <!-- Country / Market Filter -->
            <div class="md-layout-item md-size-20">
              <md-field>
                <label>Country</label>
                <md-select v-model="countryCode">
                  <md-option value="">All Markets</md-option>
                  <md-option
                    v-for="m in marketplaces"
                    :key="m.code"
                    :value="m.code"
                  >
                    {{ getCountryFlag(m.code) }} {{ m.country }} ({{ m.code }})
                  </md-option>
                </md-select>
              </md-field>
            </div>

            <!-- Order Status -->
            <div class="md-layout-item md-size-20">
              <md-field>
                <label>Order Status</label>
                <md-select v-model="orderStatus">
                  <md-option value="">All</md-option>
                  <md-option value="Confirmed">Confirmed</md-option>
                  <md-option value="Shipped">Shipped</md-option>
                  <md-option value="Out For Delivery">Out For Delivery</md-option>
                  <md-option value="Delivered">Delivered</md-option>
                </md-select>
              </md-field>
            </div>

            <!-- Exclude Tags Filter (NEW) -->
            <div class="md-layout-item md-size-25">
              <md-field>
                <label>Exclude Tags</label>
                <md-select v-model="excludeTags" multiple>
                  <md-option
                    v-for="tag in availableTags"
                    :key="tag"
                    :value="tag"
                  >
                    {{ tag }}
                  </md-option>
                </md-select>
              </md-field>
            </div>

            <!-- From Date -->
            <div class="md-layout-item md-size-25">
              <md-field>
                <label>From Date</label>
                <md-input type="date" v-model="fromDate"></md-input>
              </md-field>
            </div>

            <!-- To Date -->
            <div class="md-layout-item md-size-25">
              <md-field>
                <label>To Date</label>
                <md-input type="date" v-model="toDate"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20" v-if="this.$route.path == '/kid/subscriptions'">
              <md-checkbox v-model="uniqueRecords">
                Unique Records
              </md-checkbox>
            </div>
            <div class="md-layout-item md-size-25">
              <md-button class="md-primary" :disabled="isDisabled" @click="orderList()">Search</md-button>
            </div>
          </div>

          <!-- Legend: Row Colors + Country Badges -->
          <div class="md-layout-item md-size-100">
            <div class="row-color-legend">
              <span class="legend-title">Row Colors:</span>
              <span
                v-for="(color, product) in rowColors"
                :key="product"
                class="legend-item"
                :style="{ backgroundColor: color }"
              >
                {{ product }}
              </span>
            </div>
            <div class="row-color-legend">
              <span class="legend-title">Markets:</span>
              <span
                v-for="(meta, code) in countryMeta"
                :key="code"
                class="country-legend-badge"
                :style="{ backgroundColor: meta.bg, color: meta.color, borderColor: meta.border }"
              >
                {{ meta.flag }} {{ code }}
              </span>
            </div>
            <!-- Excluded Tags Display -->
            <div class="row-color-legend" v-if="excludeTags.length > 0">
              <span class="legend-title">Excluding Tags:</span>
              <span
                v-for="tag in excludeTags"
                :key="tag"
                class="excluded-tag-badge"
              >
                {{ tag }} <md-icon class="remove-icon" @click="removeExcludedTag(tag)">close</md-icon>
              </span>
            </div>
          </div>

          <hr>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              :style="getRowBackground(item.productNames)"
            >
              <md-table-cell md-label="Order Number" md-sort-by="orderNumber">
                <!-- Country badge -->
                <span
                  class="country-badge"
                  :style="getCountryBadgeStyle(item.countryCode)"
                  :title="getCountryName(item.countryCode)"
                >
                  {{ getCountryFlag(item.countryCode) }} {{ item.countryCode || 'GB' }}
                </span>
                
                <!-- Referral badge (if used) -->
                <span v-if="item.usedReferralCode" class="referral-badge" :title="'Referral: ' + item.usedReferralCode">
                  🎁 {{ item.usedReferralCode }}
                </span>
                
                <br>
                <a href="javascript:void(0)" @click="$router.push({ path: 'order-detail', query: { id: item._id }})">
                  {{ item.orderNumber }}
                </a>
                <span v-if="item.subscriptionType == 'subscription_cycle'">
                  <br> <b>{{ item.subscriptionType }}</b>
                </span>
              </md-table-cell>

              <md-table-cell md-label="Amount" md-sort-by="Total">
                <small><b>Total:</b> {{ getCurrencySymbol(item.currency) }}{{ item.orderTotal }}</small><br>
                <small><b>Discount:</b> {{ getCurrencySymbol(item.currency) }}{{ item.discountAmount }}</small><br>
                <small><b>Payable Amount:</b> {{ getCurrencySymbol(item.currency) }}{{ item.payableAmount }}</small><br>
                <span v-if="item.shippingAmount > 0" class="paid-delivery-badge">
                  🚚 Paid Delivery · {{ getCurrencySymbol(item.currency) }}{{ item.shippingAmount }}
                </span>
              </md-table-cell>

              <md-table-cell md-label="Email" md-sort-by="email">
                {{ item.name }}<br>
                {{ item.email }}<br>
                <strong>{{ item.phoneNumber }}</strong>
              </md-table-cell>

              <md-table-cell md-label="Order Status" md-sort-by="status">
                <span :class="statusClass(item.orderStatus)">
                  {{ item.orderStatus }}
                </span>
              </md-table-cell>

              <md-table-cell md-label="Review Count">{{ item.reviewRequestSentCount }}
                &nbsp;&nbsp;
                <button class="tag-btn-inside" :style="{'right':'unset', top: '30%'}"
                  @click="$router.push({ path: '/kid/review-request', query: { email: item.email, orderNumber: item.orderNumber }})">
                  Request Review
                </button>
              </md-table-cell>

              <md-table-cell md-label="Created" md-sort-by="created_at">{{ HumanReadableDateFormat(item.created_at) }}</md-table-cell>

              <md-table-cell md-label="Actions">
                <md-button class="md-just-icon md-info md-simple" v-if="item.subscriptionType != 'subscription_cycle'"
                  @click="$router.push({ path: 'order-detail', query: { id: item._id }})">
                  <md-icon>visibility</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>

          </md-table>

        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";

const ROW_COLORS = {
  "SAMSUNG Galaxy A16 4G": "aliceblue",
  "SAMSUNG Galaxy A17 5G": "antiquewhite",
};

const COUNTRY_META = {
  GB: { flag: '🇬🇧', name: 'United Kingdom', bg: '#e3f2fd', color: '#0d47a1', border: '#90caf9' },
  DE: { flag: '🇩🇪', name: 'Germany',        bg: '#fff3e0', color: '#e65100', border: '#ffb74d' },
  FR: { flag: '🇫🇷', name: 'France',         bg: '#f3e5f5', color: '#4a148c', border: '#ce93d8' },
  US: { flag: '🇺🇸', name: 'United States',  bg: '#e8f5e9', color: '#1b5e20', border: '#a5d6a7' },
  IE: { flag: '🇮🇪', name: 'Ireland',        bg: '#e0f2f1', color: '#004d40', border: '#80cbc4' },
  ES: { flag: '🇪🇸', name: 'Spain',          bg: '#fce4ec', color: '#880e4f', border: '#f48fb1' },
  IT: { flag: '🇮🇹', name: 'Italy',          bg: '#f1f8e9', color: '#33691e', border: '#aed581' },
  NL: { flag: '🇳🇱', name: 'Netherlands',    bg: '#fff8e1', color: '#ff6f00', border: '#ffd54f' },
  BE: { flag: '🇧🇪', name: 'Belgium',        bg: '#efebe9', color: '#3e2723', border: '#bcaaa4' },
  PT: { flag: '🇵🇹', name: 'Portugal',       bg: '#e8eaf6', color: '#1a237e', border: '#9fa8da' },
  PL: { flag: '🇵🇱', name: 'Poland',         bg: '#fbe9e7', color: '#bf360c', border: '#ffab91' },
  AT: { flag: '🇦🇹', name: 'Austria',        bg: '#fafafa', color: '#212121', border: '#bdbdbd' },
  SE: { flag: '🇸🇪', name: 'Sweden',         bg: '#fffde7', color: '#f57f17', border: '#fff176' },
  DK: { flag: '🇩🇰', name: 'Denmark',        bg: '#ffebee', color: '#b71c1c', border: '#ef9a9a' },
  FI: { flag: '🇫🇮', name: 'Finland',        bg: '#e1f5fe', color: '#01579b', border: '#81d4fa' },
};

const CURRENCY_SYMBOLS = {
  GBP: '£', EUR: '€', USD: '$', SEK: 'kr', DKK: 'kr', NOK: 'kr',
  CHF: 'Fr', PLN: 'zł', CZK: 'Kč', HUF: 'Ft', AUD: 'A$', CAD: 'C$',
};

export default {
  components: {
    Pagination,
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      currentSort: "orderId",
      currentSortOrder: "asc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      searchedData: [],
      availableTags: [],
      email: "",
      phoneNumber: "",
      orderStatus: "",
      countryCode: "",
      referralCode: "",  // ← ADD THIS
      excludeTags: [],       // ← NEW: Multiple tag exclusion
      fromDate: "",
      toDate: "",
      uniqueRecords: false,
      rowColors: ROW_COLORS,
      countryMeta: COUNTRY_META,
      marketplaces: [],
      isDisabled: false,
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },
    statusClass(status) {
      switch (status) {
        case "Confirmed":        return "badge badge-success";
        case "Shipped":          return "badge badge-primary";
        case "Out For Delivery": return "badge badge-warning";
        case "Delivered":        return "badge badge-info";
        default:                 return "";
      }
    },

    getCountryFlag(code) {
      const c = (code || 'GB').toUpperCase();
      return COUNTRY_META[c] ? COUNTRY_META[c].flag : '🌍';
    },
    getCountryName(code) {
      const c = (code || 'GB').toUpperCase();
      return COUNTRY_META[c] ? COUNTRY_META[c].name : code;
    },
    getCountryBadgeStyle(code) {
      const c = (code || 'GB').toUpperCase();
      const meta = COUNTRY_META[c] || { bg: '#eee', color: '#333', border: '#ccc' };
      return {
        backgroundColor: meta.bg,
        color: meta.color,
        border: `1px solid ${meta.border}`,
      };
    },
    getCurrencySymbol(currency) {
      if (!currency) return '£';
      return CURRENCY_SYMBOLS[currency.toUpperCase()] || currency.toUpperCase() + ' ';
    },

    async loadMarketplaces() {
      try {
        const res = await OrdersDataService.getMarketplaces();
        this.marketplaces = (res.data && res.data.data) ? res.data.data : [];
      } catch (e) {
        this.marketplaces = Object.keys(COUNTRY_META).map(code => ({
          code,
          country: COUNTRY_META[code].name,
        }));
      }
    },

    removeExcludedTag(tag) {
      this.excludeTags = this.excludeTags.filter(t => t !== tag);
      this.orderList();
    },

    orderList() {
      this.isDisabled = true;
      
      let data = {
        subscriptionType: this.$route.path == '/kid/subscriptions' ? 'subscription_cycle' : 'subscription_create',
        email: this.email,
        orderStatus: this.orderStatus,
        phoneNumber: this.phoneNumber,
        countryCode: this.countryCode,
        excludeTags: this.excludeTags,  // ← Pass excluded tags
        referralCode: this.referralCode,  // ← ADD THIS
        fromDate: this.fromDate,
        toDate: this.toDate,
        uniqueRecords: this.uniqueRecords,
      };
      
      OrdersDataService.orderList(data)
        .then((response) => {
          this.tableData = response.data.data;
          this.availableTags = response.data.tags || [];  // ← Get tags from server
          this.isDisabled = false;
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error fetching orders");
          this.isDisabled = false;
        });
    },

    formatAddress(address) {
      if (!address) return '';
      const parts = [
        address.line1, address.line2, address.city,
        address.state, address.country, address.postal_code,
      ].filter(Boolean).map(part => part.toString().replace(/,/g, ' '));
      return parts.join(' ');
    },

    async exportData() {
      if (this.tableData.length > 0) {
        let exportData = [];
        for await (let data of this.tableData) {
          const address = data.address ? this.formatAddress(data.address.address) : '';
          exportData.push([
            data.name,
            data.email,
            data.phoneNumber ? data.phoneNumber.toString() : '',
            address,
            data.countryCode || 'GB',
            (data.currency || 'GBP').toUpperCase(),
            data.orderNumber,
            data.serialNumbers && data.serialNumbers.length ? data.serialNumbers.join('|') : null,
            data.productNames && data.productNames.length ? data.productNames.join('|') : null,
            data.payableAmount,
            data.orderStatus,
            data.created_at,
          ]);
        }
        this.DownloadSampleImportFile(exportData);
      } else {
        this.$toast.error("No data to export");
      }
    },
    DownloadSampleImportFile(exportData = "") {
      let csv = 'Name,Email,Phone Number,Address,Country,Currency,Order Number,Serial Numbers,Product Names,Amount,Status,Created On\n';
      if (exportData) {
        exportData.forEach((row) => {
          csv += row.join(',');
          csv += "\n";
        });
      }
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      if (exportData) anchor.download = 'wingio-orders.csv';
      anchor.click();
    },

    getRowBackground(productsname) {
      if (!productsname) return {};
      const names = Array.isArray(productsname) ? productsname : [productsname];
      for (const name of names) {
        for (const [product, color] of Object.entries(ROW_COLORS)) {
          if (name.includes(product)) {
            return { backgroundColor: color };
          }
        }
      }
      return {};
    },
  },
  watch: {
    '$route.path'() {
      this.orderList();
    },
  },
  beforeMount() {
    this.loadMarketplaces();
    this.orderList();
  },
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}
::v-deep .md-table-cell[md-label="Email"],
::v-deep .md-table-cell[md-label="Order Status"] {
  min-width: 160px;
}
.tag-btn-inside {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 24px;
  padding: 0 8px;
  font-size: 11px;
  background: #8e24aa;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.tag-btn-inside:hover {
  background: #6a1b9a;
}

.paid-delivery-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffc107;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.row-color-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 12px;
}
.legend-title {
  font-weight: 600;
  color: #555;
  margin-right: 4px;
}
.legend-item {
  padding: 3px 10px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 11px;
  font-weight: 500;
  color: #333;
}

.country-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  margin-bottom: 4px;
}
.country-legend-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid;
  white-space: nowrap;
}

.excluded-tag-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 12px;
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ef9a9a;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.excluded-tag-badge:hover {
  background: #ffcdd2;
}

.remove-icon {
  font-size: 14px !important;
  cursor: pointer;
}
.referral-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 10px;
  font-weight: 600;
  margin-left: 4px;
  margin-bottom: 4px;
  white-space: nowrap;
  letter-spacing: 0.3px;
}
</style>